<!-- Overlay (backdrop) -->
<div
  ngpDialogOverlay
  class="sui-dialog-overlay"
  [class.sui-dialog-overlay--blur]="config.blurOverlay"
  [style]="overlayStyles"
  [ngpDialogOverlayCloseOnClick]="dialogRef.config.closeOnClick"
></div>

<!-- Dialog root (single panel). Also a boundary: header/footer triggers sit
     outside the content pane, so they resolve here instead of body. -->
<div
  ngpDialog
  class="sui-dialog-simple"
  [class]="sizeClass"
  [style]="customStyles"
  [ngpDialogRole]="dialogRef.config.role"
  [ngpDialogModal]="dialogRef.config.modal"
  data-sui-popover-boundary
>
  <header class="sui-dialog-simple__header">
    <ng-container *ngTemplateOutlet="headerTpl"></ng-container>
  </header>

  <main class="sui-dialog-simple__content" data-sui-popover-boundary>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </main>

  <footer class="sui-dialog-simple__footer">
    <ng-container *ngTemplateOutlet="footerTpl"></ng-container>
  </footer>
</div>
